<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-5">
        <div class="inbox float-e-margins">
          <div class="inbox-content mailbox-content">
            <form v-on:submit.prevent="createPoint">
              <header class="row">
                <h2 class="col-lg-7 text-center">Dados do Ponto</h2>

                <img
                  class="col-lg-3 img-circle"
                  v-if="imageUrl"
                  :src="formatImageURL"
                  alt=""
                />
              </header>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome do ponto de interesse</label>
                <input
                  type="text"
                  placeholder="Local com PDV"
                  class="form-control"
                  v-model="registerForm.form.pointName"
                />
              </div>
              <div class="form-group">
                <label>Descrição</label>
                <input
                  type="text"
                  placeholder="Ponto de pagamento"
                  class="form-control"
                  v-model="registerForm.form.description"
                />
              </div>
              <div class="form-group">
                <label>Imagem</label>
                <div v-bind="getRootProps()" class="customdropzone" id="customdropzone">
                  <input v-bind="getInputProps()" />
                  <p v-if="isDragActive">Solte a imagem aqui...</p>
                  <p v-else><i class="fa fa-cloud-upload"></i> Upload</p>
                  <div v-if="droppedFiles.length > 0" class="dropzone-file-list">
                    <span>{{ droppedFiles[0].name }}</span>
                    <i class="fa fa-times" @click.stop="droppedFiles = []"></i>
                  </div>
                </div>
              </div>

              <h4>Localização</h4>
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Latitude</label>

                  <input
                    type="text"
                    placeholder="-22"
                    class="form-control"
                    v-model="registerForm.form.location.lat"
                  />
                </div>
                <div class="form-group col-lg-6">
                  <label>Longitude</label>
                  <input
                    type="text"
                    placeholder="-42"
                    class="form-control"
                    v-model="registerForm.form.location.lng"
                  />
                </div>
              </div>

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="
                  !permissionCreate ||
                  registerForm.control.createButtonIsDisabled
                "
                v-if="!registerForm.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar ponto de interesse
              </button>

              <div v-if="registerForm.control.editModeId">
                <button
                  type="button"
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="registerForm.control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    registerForm.control.createButtonIsDisabled ||
                    !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <PointsList @enterEditMode="editMode" ref="pointsListRef" />
    </div>
  </div>
</template>
<script>
import { ref } from 'vue';
import { useDropzone } from 'vue3-dropzone';
import PointsList from './components/PointsList.vue';
import { URI } from '@/config/config';
import { toast } from '@/plugins/toast';

export default {
  components: {
    PointsList,
  },
  setup() {
    const droppedFiles = ref([]);
    function onDrop(acceptedFiles) {
      droppedFiles.value = acceptedFiles.slice(0, 1);
    }
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      multiple: false,
      maxFiles: 1,
      accept: 'image/*',
    });
    return { getRootProps, getInputProps, isDragActive, droppedFiles };
  },
  data() {
    return {
      imageUrl: '',
      registerForm: {
        form: {
          pointName: '',
          description: '',
          location: {
            lat: '',
            lng: '',
          },
        },
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
        },
      },
    };
  },
  computed: {
    formatImageURL() {
      return `${URI}${this.imageUrl}`;
    },
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'point-of-interest',
        'CREATE',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'point-of-interest',
        'UPDATE',
      );
    },
  },
  methods: {
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    editMode(data) {
      this.registerForm.control.editModeId = data._id;
      this.registerForm.form.pointName = data.pointName;
      this.registerForm.form.description = data.description;
      this.imageUrl = data.imageURL;
      const { coordinates } = data.location;
      const location = {
        lat: coordinates[0],
        lng: coordinates[1],
      };
      this.registerForm.form.location = location;
    },
    disableEditMode() {
      this.registerForm.control.editModeId = false;
      this.registerForm.form.pointName = '';
      this.registerForm.form.description = '';
      this.imageUrl = '';
      this.registerForm.form.location = {
        lat: '',
        lng: '',
      };
    },
    async getFile() {
      if (this.droppedFiles.length === 0) {
        return undefined;
      }
      const f = this.droppedFiles[0];
      const dataURL = await this.readFileAsync(f);
      return { base64: dataURL, fileName: f.name };
    },
    async createPoint() {
      try {
        const payload = {
          ...this.registerForm.form,
          file: await this.getFile(),
        };
        await this.$store.dispatch(
          'POINT-INTEREST/RegisterOfInterestList',
          payload,
        );
        await this.$refs.pointsListRef.listPoints();
        this.disableEditMode();
        toast.success('Ponto de interesse criado com sucesso!');
      } catch (error) {
        console.error(error);
        toast.error('Falha ao cadastrar ponto de interesse');
      }
    },
    async saveEdition() {
      try {
        const payload = {
          data: {
            ...this.registerForm.form,
            file: await this.getFile(),
          },
          pointOfInterestId: this.registerForm.control.editModeId,
        };
        await this.$store.dispatch(
          'POINT-INTEREST/UpdateOfInterestList',
          payload,
        );
        await this.$refs.pointsListRef.listPoints();
        this.disableEditMode();
        toast.success('Ponto de interesse atualizado com sucesso!');
      } catch (error) {
        console.error(error);
        toast.error('Falha ao atualizar ponto de interesse');
      }
    },
  },
};
</script>
